import { $t } from '@repo/i18n'

export enum FileType {
	csv,
	zip,
	image,
}

export const fileTypes = {
	[FileType.csv]: {
		accept: '.csv,text/csv',
		allowedTypes: ['text/csv', 'application/vnd.ms-excel', 'text/plain'],
		text: $t('form.upload.csv'),
	},
	[FileType.zip]: {
		accept: '.zip,application/zip,application/x-zip,application/x-zip-compressed',
		allowedTypes: ['application/zip', 'application/x-zip', 'application/x-zip-compressed'],
		text: $t('form.upload.zip'),
	},
	[FileType.image]: {
		accept: 'image/*',
		allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/svg+xml', 'image/webp'],
		text: $t('form.upload.image'),
	},
}
